"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardHomeDetails = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardHomeDetailsMixin = require("../../mixins/components/PropertyCardHomeDetailsMixin");
// Using a span so text truncation by PropertyCard.DataArea works properly.
var StyledPropertyCardHomeDetails = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledPropertyCardHomeDetails",
  componentId: "c11n-8-107-0__sc-1xo68zc-0"
})(["", ""], _PropertyCardHomeDetailsMixin.PropertyCardHomeDetailsMixin);
exports.StyledPropertyCardHomeDetails = StyledPropertyCardHomeDetails;